import { Channel } from './common/channels/channel';

export const managedServicesChannel = {
  reset: new Channel(),
};
